module.exports = {"id":"192087","name":"Georgiy Schennikov","rating":"75","photo":"./data/images/photos/4/192087.png","club":{"name":"CSKA Moscou","logo":"./data/images/clubs/CSKAMoscou.png"},"positions":["DLG","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GeorgiySchennikov0.json
// module id = 1563
// module chunks = 0